var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWeek(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_165_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.199463 21.0641C1.23646 24.9971 3.8896 28.4976 7.82433 30.524C10.9677 32.1419 14.4223 32.5574 17.6505 31.9392",
    stroke: "#1A6DA5",
    strokeWidth: 2.30369,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.69 2.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3286 30.5799C24.1616 29.2346 26.5954 27.0055 28.16 24.0383C32.0068 16.7416 29.1384 7.7451 21.7541 3.94396C17.5263 1.76774 12.7365 1.76674 8.69055 3.53148M10.2177 0.962769L8.12354 3.79415L11.5741 4.6141",
    stroke: "#1A6DA5",
    strokeWidth: 2.30369,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.38 13.195L14.585 22H11.93L15.77 13.495H11.27V11.29H18.38V13.195Z",
    fill: "#1A6DA5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_165_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33.3304,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeek);
export default __webpack_public_path__ + "static/media/week.9acc69d592ea968db40b23bcf03238df.svg";
export { ForwardRef as ReactComponent };